import { Box, HStack, Spinner, Flex, Heading } from "@reverb-ui/react";
import {
  SelectDownloadOption,
  TSelectDownloadOptionProps,
} from "presentation/components/SelectDownloadOption";
import { RangePanelInfo } from "presentation/components/RangePanelInfo";
import { ReportsFilterContext } from "presentation/containers/context-api/ReportsFilterProvider";
import { useContext } from "react";
import { LastFilterSelected } from "helper/panelsHelper";
import FilterBadge from "components/AllowFiltering/FilterBadge";

type TPanelContainerProps = {
  panelId?: string;
  panelName: string;
  children: React.ReactNode;
  isLoading?: boolean;
  rangeName?: string;
  downloadOptions?: TSelectDownloadOptionProps;
  printBreakClass?: boolean;
};

const PanelContainer: React.FC<TPanelContainerProps> = ({
  panelId,
  panelName,
  children,
  isLoading,
  rangeName,
  downloadOptions,
  printBreakClass = true,
}) => {
  const { comparisonParams, filterState } = useContext(ReportsFilterContext);
  const currentFilterState =
    filterState[downloadOptions?.filterStateIndex ?? 0];
  const experienceName = LastFilterSelected(currentFilterState);

  return (
    <Box w="full" className={printBreakClass ? "container-print-break" : ""}>
      <Box bg="gray.50" w="full" p={6} id={panelId}>
        <Flex flexDir="column" w="100%">
          {comparisonParams && experienceName && (
            <Flex>
              <FilterBadge
                index={downloadOptions?.filterStateIndex ?? 0}
                maxWidthText={700}
              >
                {experienceName.experienceName}
              </FilterBadge>
            </Flex>
          )}
          <Flex justifyContent="space-between">
            <HStack py={comparisonParams ? 3 : 4}>
              <Heading
                fontSize="4xl"
                color="gray.700"
                fontWeight="bold"
                whiteSpace="nowrap"
              >
                {panelName}
              </Heading>
              {isLoading ? (
                <Box paddingLeft="1rem">
                  <Spinner size="sm" color="blue.500" />
                </Box>
              ) : (
                rangeName && <RangePanelInfo rangeValue={rangeName} />
              )}
            </HStack>
            {downloadOptions && (
              <SelectDownloadOption
                filterStateIndex={downloadOptions.filterStateIndex}
                onClickGenerateCSV={downloadOptions.onClickGenerateCSV}
                downloadingReports={downloadOptions.downloadingReports}
                panelInfo={downloadOptions.panelInfo}
              />
            )}
          </Flex>
        </Flex>
        {children}
      </Box>
    </Box>
  );
};

export default PanelContainer;
